import URLBuilder from '@/lib/url-builder';

export default function contentNewsListUrl(
  urlQuerySearchParams?: URLSearchParams | null | undefined,
  urlHash?: string | null | undefined,
): string {
  const url = new URLBuilder('/zpravy', urlQuerySearchParams, urlHash);
  return url.build();
}
